import { InfoIcon } from "../../svg/info-icon";

interface NoDataProps {
  height?: string;
  width?: string;
  stroke?: string;
  text?: string;
}

/**
 * Empty-state placeholder for RisaCustomTable when there are no rows.
 *
 * @param props - Optional icon sizing and custom empty-state text
 * @returns Empty-state UI
 */
const NoData = (props: NoDataProps) => {
  return (
    <div className="no-data-container">
      <InfoIcon
        height={props.height || "24"}
        width={props.width || "24"}
        stroke={props.stroke || "#0056D6"}
      />
      <div className="no-data-container__text">
        {props.text || "No Data Found"}
      </div>
    </div>
  );
};

export default NoData;
